document.addEventListener('DOMContentLoaded', function () {
	const TOTAL_LIMIT = 29;
	const container = document.querySelector('.product-description');
	if (!container) return;

	const shouldToggle = container.dataset.pdShouldToggle === 'true';

	// Get description and attributes sections
	let descriptionContent = container.querySelector('.product-description-content');
	const attributesSection = container.querySelector('.product-attributes-section');
	const customFeaturesSection = container.querySelector('.custom-features-section');
	const hasAttributesDisplay = !!container.querySelector('.product-attributes-display');
	const hasCustomFeaturesDisplay = !!container.querySelector('.custom-features-display');
	const forceReadMore = shouldToggle || hasAttributesDisplay || hasCustomFeaturesDisplay;

	// If no description content, don't apply readmore
	if (!descriptionContent) {
		if (!forceReadMore) {
			return;
		}

		descriptionContent = document.createElement('div');
		descriptionContent.className = 'product-description-content';

		if (attributesSection) {
			container.insertBefore(descriptionContent, attributesSection);
		} else if (customFeaturesSection) {
			container.insertBefore(descriptionContent, customFeaturesSection);
		} else {
			container.appendChild(descriptionContent);
		}
	}

	// 1. Try to grab <p> tags from description content; if none, wrap text nodes into a new .pd-text div
	let elems = Array.from(descriptionContent.querySelectorAll('p'));
	if (!elems.length) {
		const wrapper = document.createElement('div');
		wrapper.className = 'pd-text';
		// Move only text nodes & non-<a> elements into wrapper
		Array.from(descriptionContent.childNodes).forEach((node) => {
			if (
				node.nodeType === Node.TEXT_NODE ||
				(node.nodeType === Node.ELEMENT_NODE && node.tagName !== 'A')
			) {
				wrapper.appendChild(node);
			}
		});
		descriptionContent.appendChild(wrapper);
		elems = [wrapper];
	}

	// 2. Count total words; if under limit, do nothing
	const totalWords = elems.reduce((sum, el) => {
		return sum + el.textContent.trim().split(/\s+/).length;
	}, 0);
	if (!forceReadMore && totalWords <= TOTAL_LIMIT) {
		container.dataset.pdState = 'static';
		return;
	}

	// 3. Stash each element's full text
	elems.forEach((el) => {
		el.dataset.full = el.textContent.trim();
	});

	let readMore = container.querySelector('.read-more');
	let readLess = container.querySelector('.read-less');

	if (!readMore || !readLess) {
		const toggleWrapper =
			container.querySelector('.product-description__toggle') ||
			container.appendChild(document.createElement('div'));

		toggleWrapper.classList.add('product-description__toggle');

		if (!readMore) {
			readMore = document.createElement('a');
			readMore.className = 'read-more';
			readMore.href = '#';
			readMore.textContent = 'קראו עוד';
			toggleWrapper.appendChild(readMore);
		}

		if (!readLess) {
			readLess = document.createElement('a');
			readLess.className = 'read-less';
			readLess.href = '#';
			readLess.textContent = 'קראו פחות';
			toggleWrapper.appendChild(readLess);
		}
	}

	// 4. Build the truncated preview
	function applyPreview() {
		container.dataset.pdState = 'collapsed';
		readMore.setAttribute('aria-expanded', 'false');
		readLess.setAttribute('aria-expanded', 'false');

		let remaining = TOTAL_LIMIT;
		elems.forEach((el) => {
			const words = el.dataset.full.split(/\s+/);
			const showCount = Math.min(words.length, remaining);
			if (showCount === 0) {
				el.style.display = 'none';
			} else {
				el.style.display = '';
				el.textContent =
					showCount < words.length
						? words.slice(0, showCount).join(' ') + '…'
						: el.dataset.full;
				remaining -= showCount;
			}
		});

		// Hide attributes section in preview
		if (attributesSection) {
			attributesSection.style.display = 'none';
		}

		// Hide custom features section in preview
		if (customFeaturesSection) {
			customFeaturesSection.style.display = 'none';
		}
	}
	applyPreview();

	// 5. Toggle handlers
	readMore.addEventListener('click', (e) => {
		e.preventDefault();
		elems.forEach((el) => {
			el.style.display = '';
			el.textContent = el.dataset.full;
		});

		// Show attributes section when expanded
		if (attributesSection) {
			attributesSection.style.display = '';
		}

		// Show custom features section when expanded
		if (customFeaturesSection) {
			customFeaturesSection.style.display = '';
		}

		container.dataset.pdState = 'expanded';
		readMore.setAttribute('aria-expanded', 'true');
		readLess.setAttribute('aria-expanded', 'true');
	});

	readLess.addEventListener('click', (e) => {
		e.preventDefault();
		applyPreview();
	});
});
